var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotationsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H24C32.8366 0 40 7.16344 40 16V24C40 32.8366 32.8366 40 24 40H16C7.16344 40 0 32.8366 0 24V16Z",
    fill: "#F2F5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 22.25V19.625C27.5 18.7299 27.1444 17.8715 26.5115 17.2385C25.8786 16.6056 25.0201 16.25 24.125 16.25H22.625C22.3266 16.25 22.0405 16.1315 21.8295 15.9205C21.6185 15.7095 21.5 15.4234 21.5 15.125V13.625C21.5 12.7299 21.1444 11.8714 20.5115 11.2385C19.8785 10.6056 19.0201 10.25 18.125 10.25H16.25M20 19.25V26.75M22.25 20.284C21.1203 19.9931 19.9449 19.9241 18.789 20.081C18.253 20.153 17.815 20.559 17.768 21.098C17.7561 21.2317 17.7501 21.3658 17.75 21.5C17.75 21.964 18.086 22.344 18.525 22.494L21.475 23.506C21.915 23.656 22.25 24.036 22.25 24.5C22.25 24.636 22.244 24.77 22.232 24.902C22.185 25.441 21.747 25.847 21.211 25.919C20.055 26.0743 18.8799 26.0054 17.75 25.716M18.5 10.25H13.625C13.004 10.25 12.5 10.754 12.5 11.375V28.625C12.5 29.246 13.004 29.75 13.625 29.75H26.375C26.996 29.75 27.5 29.246 27.5 28.625V19.25C27.5 16.8631 26.5518 14.5739 24.864 12.886C23.1761 11.1982 20.8869 10.25 18.5 10.25Z",
    stroke: "#525355",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationsIcon);
export default __webpack_public_path__ + "static/media/quotationsIcon.53d5e5876649b86ea5d0c0443f80ddea.svg";
export { ForwardRef as ReactComponent };